<!--
 * @Descripttion: 未登录loading
 * @version: 
 * @Author: Terry
 * @Date: 2021-10-25 17:06:53
 * @LastEditors: Terry
 * @LastEditTime: 2021-10-25 17:52:44
-->
<template>
  <div class="no-login">
    <div class="first-loading-wrp">
      <div class="loading-wrp">
        <span class="img-wrap">
          <img
            class="spin"
            src="data:image/png;base64,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"
          />
        </span>
      </div>
      <div style="" class="joining">正在进入会议</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NotLogged',
  components: {},
  props: {},
  computed: {},
  watch: {},
  methods: {}
}
</script>

<style lang="less" scoped>
.no-login {
  height: 100%;
}
.first-loading-wrp {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  height: 100%;
  background: url('~@/assets/img/bg2_img.png') no-repeat;
  background-size: cover;
  color: #42424a;

  .joining {
    display: flex;
    justify-content: center;
    align-items: center;
    line-height: 54px;
  }
}
.first-loading-wrp .loading-wrp {
  /* padding:98px;*/
  display: flex;
  justify-content: center;
  align-items: center;
}
.img-wrap {
  animation: antRotate 1.2s infinite linear;
  position: relative;
  display: inline-block;
  font-size: 36px;
  box-sizing: border-box;
}
.spin {
  display: block;
  width: 36px;
  height: 36px;
}
</style>
